export default "__VITE_ASSET__171d37bd__"